import { AssociateContainer, Container, DataContainer, FixitLogo, ProfilePictureWrapper, StarBadge, ActionContainer } from "./styles";
import logoImage from '../../../../../../assets/imagem_coringa.png'
import { FaStar, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { MdOutlineWhatsapp } from "react-icons/md";
import api from "../../../../../../services/api";
import { SolidButton } from "../../../../../../components/SolidButton";

interface IAssociatesItemProps {
  id: string;
  name: string;
  phone: string;
  instagram: string;
  profile_picture: string;
  professional_number: string;
  distance: string;
  duration: string;
  rating: number;
  expertise?: string;
  city?: string;
  state?: string;
  isPremium?: boolean;
}
export default function AssociatesItem(associate: IAssociatesItemProps) {

  async function assignLicenseeToALead(licenseeId: string) {
    try {
      await api.put(`patients-leads/update-patient-lead/${localStorage.getItem('@FixitApp:Lead')}`, {
        licensee_id: licenseeId
      })
    } catch (error) {
      console.log(error)
    }
  }

  function formatPhoneNumber(phoneNumber: string) {
    const cleaned = phoneNumber.replace(/\D/g, '');

    if (cleaned.length === 11) {
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
    }
  }

  return (
    <Container>
      <AssociateContainer>
        <ProfilePictureWrapper>
          <FixitLogo src={associate.profile_picture ? `${process.env.REACT_APP_STORAGE_BASE_URL}${associate.profile_picture}` : logoImage} alt='Fix it Logo' />
          <StarBadge isPremium={associate.isPremium}>
            <FaStar size={14} />
          </StarBadge>
        </ProfilePictureWrapper>
        
        <DataContainer>
          <div className="header">
            <div>
              <h3>{associate.name}</h3>
              {associate.expertise && (
                <p className="profession-text">
                  {associate.expertise} {associate.professional_number && `- ${associate.professional_number}`}
                </p>
              )}
            </div>
          </div>

          <div className="distance-info">
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <FaMapMarkerAlt size={14} color="var(--fixit)" />
              <span style={{ fontWeight: 600 }}>{associate.distance}</span>
            </div>
            <span style={{ color: '#D3D3D3' }}>|</span>
            <span>
              {associate.city && associate.state ? `${associate.city}/${associate.state}` : 'Localização não informada'}
            </span>
          </div>
          
          <div className="distance-info" style={{ marginTop: '0px' }}>
            <span>{formatPhoneNumber(associate.phone)}</span>
          </div>

        </DataContainer>
      </AssociateContainer>

      <ActionContainer>
        <SolidButton 
          text={<><FaPhoneAlt size={14} style={{ marginRight: '8px' }} /> Ligar</>}
          buttonColor="var(--fixit)" 
          buttonHoverColor="var(--fixit-hover)"
          buttonHeight={45}
          onClick={(e: any) => {
            e.preventDefault();
            assignLicenseeToALead(associate.id);
            window.open(`tel:+55${associate.phone.replace(/\D/g, '')}`, '_self');
          }}
        />
        
        <SolidButton 
          text={<><MdOutlineWhatsapp size={20} style={{ marginRight: '8px' }} /> WhatsApp</>}
          buttonColor="var(--active-green)" 
          buttonHoverColor="var(--active-green-hover)"
          buttonHeight={45}
          onClick={(e: any) => {
            e.preventDefault();
            assignLicenseeToALead(associate.id);
            window.open(`http://wa.me/+55${associate.phone.replace(/\D/g, '')}`, '_blank', 'noopener,noreferrer');
          }}
        />
      </ActionContainer>

    </Container>
  )
}
